module.exports = __webpack_public_path__ + "static/media/img.9e338862.jpg";